import React, {FC, useContext, useEffect, useRef} from 'react';
import style from './style.module.scss';
import {CatalogListHeader} from 'modules/products/components/CatalogListHeader';
import _throttle from 'lodash/throttle';
import ExpressOrderAppliedFilter from 'plugins/modules/filter/components/AppliedFilters/ExpressOrderAppliedFilter';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';

const FIXED_HEADER_OFFSET_SCROLL_UP = 118;
const FIXED_HEADER_OFFSET_SCROLL_DOWN = 70;

export const CatalogListHeaderSticky: FC = () => {
    const {wineShop} = useContext(FilterPickupTodayButtonContext);

    const lastScrollYPositionRef = useRef<number>(0);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            const element = ref.current;

            if (!element) {
                return;
            }

            const currentWindowScrollY = window.scrollY;
            const deltaWindowScrollY = currentWindowScrollY - lastScrollYPositionRef.current;
            const isScrollUp = 0 > deltaWindowScrollY;

            if (isScrollUp) {
                element.style.top = `${FIXED_HEADER_OFFSET_SCROLL_UP}px`;
                element.style.transition = 'top 600ms ease';
            } else {
                element.style.top = `${FIXED_HEADER_OFFSET_SCROLL_DOWN}px`;
                element.style.transition = 'top 200ms ease';
            }

            lastScrollYPositionRef.current = currentWindowScrollY;
        };

        const throttledScroll = _throttle(handleScroll, 100);

        window.addEventListener('scroll', throttledScroll);

        return () => {
            window.removeEventListener('scroll', throttledScroll);
        };
    }, []);

    return (
        <div className={style.main} ref={ref}>
            <div className={style.desktopControls}>
                <CatalogListHeader />
                {wineShop && (
                    <div className={style.expressOrderTablet}>
                        <ExpressOrderAppliedFilter />
                    </div>
                )}
            </div>
        </div>
    );
};
